const SVG_BASE_HEIGHT_PX = 24;

export function normalizeStrokeWidth(number: number, height: number): number {
  return (height / SVG_BASE_HEIGHT_PX) * number;
}
